import type { TableBodyProps } from './types'

export const Body = (props: TableBodyProps) => <tbody {...props} />
